import i18n from '../i18n';

export default class LocationType {
  public static readonly NONE = new LocationType('', '');
  public static readonly LOCATION01 = new LocationType('A0', 'A0');
  public static readonly LOCATION02 = new LocationType('A1', 'A1');
  public static readonly LOCATION03 = new LocationType('A2', 'A2');
  public static readonly LOCATION04 = new LocationType('A3', 'A3');
  public static readonly LOCATION05 = new LocationType('A4', 'A4');
  public static readonly LOCATION06 = new LocationType('A5', 'A5');
  public static readonly LOCATION07 = new LocationType('A6', 'A6');
  public static readonly LOCATION08 = new LocationType('A7', 'A7');
  public static readonly LOCATION11 = new LocationType('B0', 'B0');
  public static readonly LOCATION12 = new LocationType('B1', 'B1');
  public static readonly LOCATION13 = new LocationType('B2', 'B2');
  public static readonly LOCATION14 = new LocationType('B3', 'B3');
  public static readonly LOCATION15 = new LocationType('B4', 'B4');
  public static readonly LOCATION16 = new LocationType('B5', 'B5');
  public static readonly LOCATION17 = new LocationType('B6', 'B6');
  public static readonly LOCATION18 = new LocationType('B7', 'B7');
  public static readonly LOCATION21 = new LocationType('C0', 'C0');
  public static readonly LOCATION22 = new LocationType('C1', 'C1');
  public static readonly LOCATION23 = new LocationType('C2', 'C2');
  public static readonly LOCATION24 = new LocationType('C3', 'C3');
  public static readonly LOCATION25 = new LocationType('C4', 'C4');
  public static readonly LOCATION26 = new LocationType('C5', 'C5');
  public static readonly LOCATION27 = new LocationType('C6', 'C6');
  // public static readonly NONE = new LocationType('0', '-');
  // public static readonly LOCATION01 = new LocationType('01', 'A0');
  // public static readonly LOCATION02 = new LocationType('02', 'A1');
  // public static readonly LOCATION03 = new LocationType('03', 'A2');
  // public static readonly LOCATION04 = new LocationType('04', 'A3');
  // public static readonly LOCATION05 = new LocationType('05', 'A4');
  // public static readonly LOCATION06 = new LocationType('06', 'A5');
  // public static readonly LOCATION07 = new LocationType('07', 'A6');
  // public static readonly LOCATION08 = new LocationType('08', 'A7');
  // public static readonly LOCATION11 = new LocationType('11', 'B0');
  // public static readonly LOCATION12 = new LocationType('12', 'B1');
  // public static readonly LOCATION13 = new LocationType('13', 'B2');
  // public static readonly LOCATION14 = new LocationType('14', 'B3');
  // public static readonly LOCATION15 = new LocationType('15', 'B4');
  // public static readonly LOCATION16 = new LocationType('16', 'B5');
  // public static readonly LOCATION17 = new LocationType('17', 'B6');
  // public static readonly LOCATION18 = new LocationType('18', 'B7');
  // public static readonly LOCATION21 = new LocationType('21', 'C0');
  // public static readonly LOCATION22 = new LocationType('22', 'C1');
  // public static readonly LOCATION23 = new LocationType('23', 'C2');
  // public static readonly LOCATION24 = new LocationType('24', 'C3');
  // public static readonly LOCATION25 = new LocationType('25', 'C4');
  // public static readonly LOCATION26 = new LocationType('26', 'C5');
  // public static readonly LOCATION27 = new LocationType('27', 'C6');

  public static valueOf(value: string): LocationType {
    for (const v of this.values()) {
      if (v.value === value) {
        return v;
      }
    }
    return LocationType.NONE;
  }

  public static getLocationTxt(value: string): string {
    for (const v of this.values()) {
      if (v.value === value) {
        return v.text;
      }
    }
    return LocationType.NONE.text;
  }

  // 全データ
  public static values(): any {
    return [
      { value: this.NONE.value, text: i18n.t(this.NONE.text) },
      { value: this.LOCATION01.value, text: i18n.t(this.LOCATION01.text) },
      { value: this.LOCATION02.value, text: i18n.t(this.LOCATION02.text) },
      { value: this.LOCATION03.value, text: i18n.t(this.LOCATION03.text) },
      { value: this.LOCATION04.value, text: i18n.t(this.LOCATION04.text) },
      { value: this.LOCATION05.value, text: i18n.t(this.LOCATION05.text) },
      { value: this.LOCATION06.value, text: i18n.t(this.LOCATION06.text) },
      { value: this.LOCATION07.value, text: i18n.t(this.LOCATION07.text) },
      { value: this.LOCATION08.value, text: i18n.t(this.LOCATION08.text) },
      { value: this.LOCATION11.value, text: i18n.t(this.LOCATION11.text) },
      { value: this.LOCATION12.value, text: i18n.t(this.LOCATION12.text) },
      { value: this.LOCATION13.value, text: i18n.t(this.LOCATION13.text) },
      { value: this.LOCATION14.value, text: i18n.t(this.LOCATION14.text) },
      { value: this.LOCATION15.value, text: i18n.t(this.LOCATION15.text) },
      { value: this.LOCATION16.value, text: i18n.t(this.LOCATION16.text) },
      { value: this.LOCATION17.value, text: i18n.t(this.LOCATION17.text) },
      { value: this.LOCATION18.value, text: i18n.t(this.LOCATION18.text) },
      { value: this.LOCATION21.value, text: i18n.t(this.LOCATION21.text) },
      { value: this.LOCATION22.value, text: i18n.t(this.LOCATION22.text) },
      { value: this.LOCATION23.value, text: i18n.t(this.LOCATION23.text) },
      { value: this.LOCATION24.value, text: i18n.t(this.LOCATION24.text) },
      { value: this.LOCATION25.value, text: i18n.t(this.LOCATION25.text) },
      { value: this.LOCATION26.value, text: i18n.t(this.LOCATION26.text) },
      { value: this.LOCATION27.value, text: i18n.t(this.LOCATION27.text) },
    ];
  }

  private constructor(public readonly value: string, public readonly text: string) {}
  public getValue(): string { return this.value; }
  public getText(): string { return this.text; }
  public equals(other: LocationType): boolean { return (this.text === other.text) ? true : false; }
  public toString(): string { return `${this.text}(${this.text})`; }
}
